module.exports = __webpack_public_path__ + "img/23.c62edc06.png";